export interface IApplicationState {


    bgSoundPlay: any;
    effectSoundPlay: any;


}

const initialState: IApplicationState = {
    bgSoundPlay: false,
    effectSoundPlay: true,

};

export enum actionTypes {


    BG_SOUND_PLAY = '@@gameLevelSound/BG_SOUND_PLAY',
    EFFECT_SOUND_PLAY = '@@gameLevelSound/EFFECT_SOUND_PLAY',

}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { bgSoundPlay, effectSoundPlay } = action;

    switch (action.type) {



        case actionTypes.BG_SOUND_PLAY:
            return {
                ...state, bgSoundPlay: bgSoundPlay,
            };
        case actionTypes.EFFECT_SOUND_PLAY:
            return {
                ...state, effectSoundPlay: effectSoundPlay,
            };

        default:
            return state;
    }
}

export const actions = {

    playBgSound: (bgSoundPlay: any): any => ({ type: actionTypes.BG_SOUND_PLAY, bgSoundPlay }),
    playEffectSound: (effectSoundPlay: any): any => ({ type: actionTypes.EFFECT_SOUND_PLAY, effectSoundPlay }),

};